import * as React from 'react';

import * as styles from './GeoSuggestDesktopMenu.css';
import { TResultSuggestion } from '../../../../types/suggest';
import { IGeoSuggestProps } from '../../types';

interface IGeoSuggestDesktopMenuProps extends Pick<IGeoSuggestProps, 'suggestions' | 'onItemSelect'> {
  open: boolean;
  onClose(): void;
}

export const GeoSuggestDesktopMenu: React.FC<IGeoSuggestDesktopMenuProps> = ({
  suggestions,
  onItemSelect,
  onClose,
  open,
}) => {
  if (!open) {
    return null;
  }

  const handleItemSelect = (item: TResultSuggestion) => {
    onItemSelect(item);
    onClose();
  };

  return (
    <div className={styles['menu']}>
      {suggestions && (
        <ul className={styles['suggestions']}>
          {suggestions.map((item, index) => (
            <li key={`suggestion_${index}`} className={styles['suggestion-item']}>
              <button type="button" className={styles['suggestion-button']} onClick={() => handleItemSelect(item)}>
                {item.displayName}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
